

export const Educations=[
    {
      id:"1",
      course:'B.E in CSE',
      college:'Amrita College Of Engineering and technology',
      startYear:'2019',
      endYear:'2023',
      mark:'7.64 Cgpa',
      desc: 'Studied computer science engineering with a focus on software development and algorithms.',
    }, 
    {
      id:"2",
      course:'Higher Secondary Education',
      college:'Alphonsa Matric Higher Secondary School',
      startYear:'2017',
      endYear:'2019',
      mark:'61 %',
      desc: 'Completed higher secondary education with a focus on computer science .',
 
    },
    {
      id:"3",
      course:'SSLC',
      college:'Alphonsa Matric Higher Secondary School',
      startYear:'2016',
      endYear:'2017',
      mark:'84 %',
      desc: 'Successfully completed secondary school education with excellent performance.',
 
  },

]
